import React from 'react';
import Schema, { Props } from '../docs/Schema';

const AggregatorSchema: React.FC<Props> = (props: Props) => {
  return <Schema {...props} exchangeSpec='aggregator' />;
};

export default AggregatorSchema;
